.AddButton1524782716__root {
  -st-states: size(enum(tiny, small));

  width: 100%;
  height: 100%;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #a8caff;
  border-radius: 4px;
  background-color: #fff;
}

.AddButton1524782716__root.AddButton1524782716---size-4-tiny {
  min-width: 24px;
  min-height: 24px;
}

.AddButton1524782716__root.AddButton1524782716---size-5-small {
  min-width: 30px;
  min-height: 30px;
}

.AddButton1524782716__root:not(:disabled) {
  cursor: pointer;
}

.AddButton1524782716__root:hover:not(:disabled) {
  background-color: #e7f0ff;
}

.AddButton1524782716__root:focus {
  outline: 2px solid #a8caff;
  outline-offset: 1px;
}

.AddButton1524782716__root:disabled {
  border-color: #d5d5d5;
}

.AddButton1524782716__plusIcon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.AddButton1524782716__plusIcon > svg {
  fill: #116dff;
}

.AddButton1524782716__root:disabled .AddButton1524782716__plusIcon > svg {
  fill: #898989;
}

/* st-namespace-reference="../../../../src/atoms/AddButton/AddButton.st.css" */